const getTime = () => {
  const date = new Date()
  const hours = date.getHours()
  const minutes = date.getMinutes()
  const seconds = date.getSeconds()
  return `${hours}${minutes < 10 ? ':0' : ':'}${minutes}${seconds < 10 ? ':0' : ':'}${seconds}`
}

const initialDirectory = '/About'

const age = new Date().getFullYear() - 1997 - 1

const introduction = [
  {
    type: 'system',
    label: 'System',
    content: `cd ${initialDirectory}`
  },
  {
    type: 'system',
    label: 'System',
    content: 'Thanks for your visit, let me introduce myself.'
  },
  {
    time: getTime(),
    type: 'info',
    label: 'Name:',
    content: 'SimonAKing'
  },
  {
    time: getTime(),
    type: 'info',
    label: 'Sex:',
    content: 'Male'
  },
  {
    time: getTime(),
    type: 'info',
    label: 'Age:',
    content: `${age}`
  },
  {
    time: getTime(),
    type: 'info',
    label: 'Email:',
    content: 'hi@simonaking.com'
  }
]

export default {
  intro: {
    description: 'Introducting myself again.',
    run(print) {
      let i = 0
      return new Promise(resolve => {
        const interval = setInterval(() => {
          print(introduction[i])
          i++
          if (!introduction[i]) {
            clearInterval(interval)
            resolve({ type: 'success', label: 'Done', content: 'Myself introduction is over!' })
          }
        }, 500)
      })
    }
  },
  echo: {
    description: 'Echoes input.',
    run(print, input) {
      return new Promise(resolve => {
        print({
          time: getTime(),
          label: 'Echo',
          type: 'success',
          content: input
        })
        resolve({ type: 'success', label: '', content: '' })
      })
    }
  },
  open: {
    description: 'Open a specified url in a new tab.',
    run(print, input) {
      return new Promise((resolve) => {
        if (!input) {
          resolve({ type: 'error', label: 'Error', content: 'a url is required!' })
          return
        }
        if (!input.startsWith('http')) {
          resolve({ type: 'error', label: 'Error', content: 'Please add `http` prefix!' })
          return
        }
        print({ type: 'success', label: 'Success', content: 'Opening' })

        window.open(input, '_blank')
        resolve({ type: 'success', label: 'Done', content: 'Page Opened!' })
      })
    }
  },
  gallery: {
    description: 'Open my gallery in a new tab.',
    run(print) {
      return new Promise((resolve) => {
        print({ type: 'success', label: 'Success', content: 'Opening' })

        window.open('https://simonaking.com/gallery/', '_blank')
        resolve({ type: 'success', label: 'Done', content: ':)' })
      })
    }
  },
  weibo: {
    description: 'Open my weibo in a new tab.',
    run(print) {
      return new Promise((resolve) => {
        print({ type: 'success', label: 'Success', content: 'Opening' })

        window.open('https://simonaking.com/blog/weibo/', '_blank')
        resolve({ type: 'success', label: 'Done', content: ':)' })
      })
    }
  },
  projects: {
    description: 'Open my projects in a new tab.',
    run(print) {
      return new Promise((resolve) => {
        print({ type: 'success', label: 'Success', content: 'Opening' })

        window.open('https://simonaking.com/projects/', '_blank')
        resolve({ type: 'success', label: 'Done', content: ':)' })
      })
    }
  },
  2048: {
    description: 'Open a 2048 Game in a new tab.',
    run(print) {
      return new Promise((resolve) => {
        print({ type: 'success', label: 'Success', content: 'Opening' })

        window.open('https://simonaking.com/2048', '_blank')
        resolve({ type: 'success', label: 'Done', content: 'Game Start!' })
      })
    }
  },
  music: {
    description: 'Open my favorite music in a new tab.',
    run(print) {
      return new Promise((resolve) => {
        print({ type: 'success', label: 'Success', content: 'Opening' })

        window.open('https://music.163.com/#/playlist?id=631778759', '_blank')
        resolve({ type: 'success', label: 'Done', content: ':)' })
      })
    }
  },
  newsletter: {
    description: 'Open my subscribed newsletters in a new tab.',
    run(print) {
      return new Promise((resolve) => {
        print({ type: 'success', label: 'Success', content: 'Opening' })

        window.open('https://simonaking.com/newsletter/', '_blank')
        resolve({ type: 'success', label: 'Done', content: ':)' })
      })
    }
  }
}
